export interface aiModel {
  prompt: string;
  navigation: string;
  step: string;
  current_location?: current_location;
}

export interface aiModelStart {
  navigation: string;
  step: string;
}

export interface AiChatOption {
  name: string;
  value?: string;
  type?: string;
}

export enum MessageType {
  CHAT = 'CHAT',
  SYSTEM = 'SYSTEM',
}

export interface current_location {
  country_code: string;
  lat: number;
  long: number;
  address: string;
  address_ar: string;
  area: string;
  state: string;
  street: string;
  block: string;
  block_ar: string;
  neighborhood: string;
  neighborhood_ar: string;
  civil_id: string;
}

export interface AIResponse {
  data: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    final: any;
    chat_id?: string;
    chat_type?: 'HYBRID' | 'AI_BOOKING_OR_SUPPORT' | string;
    continuing_ticket?: boolean;
    intent?: string;
    message: string;
    media?: string[];
    help_guide_slug?: string;
    pre_decision_tree_message?: string;
    message_type?: MessageType | string;
    agent_name?: string;
    agent_id?: string;
    options?: AiChatOption[];
    navigation: string;
    next_navigation: string;
    next_step: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    selection: any;
    step: string;
  };
}

export interface AiConvoChatPayload {
  chat_id: string;
}

export interface AiConvoIdleMessage {
  id: string;
  chat_id: string;
  sender_id: string;
  content: string;
  type: string;
  is_read: boolean;
  created_at: string;
}

export interface AiConvoIdleResponse {
  statusCode: number;
  status: number;
  message: string | null;
  data: {
    /** Null when a human agent owns the chat (HYBRID). */
    message: AiConvoIdleMessage | null;
  };
}

export interface AiConvoEndResponse {
  statusCode: number;
  status: number;
  message: string | null;
  data: {
    closed: boolean;
  };
}
